import {
  Box,
  Step,
  StepLabel,
  Stepper,
  Tooltip,
  Typography,
} from '@mui/material';
import StepperProps from '../../lib/StepperProps';

/**
 * A component that holds the stepper for the client onboarding
 * @param props The properties for a stepper
 * @returns A stepper to go through the client onboarding steps
 */
const ClientOnboardingStepper = (props: StepperProps) => {
  return (
    <Box height="100%" display="flex" flexDirection="column">
      <Box height="100%" display="flex" overflow="auto">
        <Stepper
          activeStep={props.activeStep}
          orientation="vertical"
          sx={{
            margin: 'auto 0',
            padding: '1em',
            '& .MuiStepConnector-line': {
              minHeight: '60px',
            },
          }}
        >
          {props.steps.map((s, i) => (
            <Step
              key={i}
              completed={s.complete}
              sx={{
                '& .MuiStepLabel-root .Mui-completed .MuiStepIcon-root': {
                  color: 'success.main',
                },
                '& .MuiStepLabel-root .Mui-active .MuiStepIcon-root': {
                  color: props.steps[i].complete
                    ? 'success.main'
                    : 'primary.main',
                },
                ...(i == props.latestStep
                  ? {
                      '& .MuiSvgIcon-root': {
                        color: 'primary.main',
                      },
                      '& .MuiStepLabel-label': {
                        color: 'text.primary',
                        fontSize: '1em',
                      },
                    }
                  : {
                      '& .MuiStepLabel-label': {
                        fontSize: '1em',
                      },
                    }),
                '& .MuiStepLabel-root': {
                  textWrap: 'nowrap',
                  cursor:
                    props.steps[i].complete || i == props.latestStep
                      ? 'pointer'
                      : 'help',
                },
              }}
              disabled={false}
            >
              <Tooltip
                key={i}
                title={
                  props.steps[i].complete
                    ? 'Step Complete'
                    : i == props.latestStep
                      ? 'Current Step'
                      : 'Upcoming Step'
                }
                arrow
              >
                <StepLabel
                  onClick={() => {
                    if (props.steps[i].complete || i == props.latestStep)
                      props.setActiveStep(i);
                  }}
                >
                  {props.activeStep == i ? (
                    <Typography fontWeight="700" fontSize="1.2em">
                      {s.stepTitle}
                    </Typography>
                  ) : (
                    s.stepTitle
                  )}
                </StepLabel>
              </Tooltip>
            </Step>
          ))}
        </Stepper>
      </Box>
    </Box>
  );
};

export default ClientOnboardingStepper;
